import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage, useT } from "@/lib/LanguageContext";
import { adminHref } from "../../adminPath";
import { fmtCount } from "../format";
import { crmHref } from "../paths";
import useCrmMoney from "../hooks/useCrmMoney";
import MetricCard from "../ui/MetricCard";
import { CRM } from "../../../constants/testIds/crm";

/**
 * The row of six metric cards (spec table "Metric cards"). Each card but Total revenue
 * opens the filtered list for the SAME period the server reports (`period.from/to`):
 * course / product buyers on the Clients list, completed online / in-person sessions on
 * the Bookings list, new clients newest first.
 */
export default function MetricGrid({ data }) {
  const t = useT("crm");
  const { lang } = useLanguage();
  const money = useCrmMoney();
  const navigate = useNavigate();
  const { from, to } = data.period || {};
  const c = data.cards || {};
  const q = (params) => new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
  const buyers = (kind) => navigate(`${crmHref("/clients")}?${q({ purchased_kind: kind, purchased_from: from, purchased_to: to })}`);
  const sessions = (mode) => navigate(`${adminHref("/admin/bookings")}?${q({ status: "completed", delivery_mode: mode, from, to })}`);

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
      <MetricCard testId={CRM.perfMetric("courses")} label={t("perf.courses")} value={fmtCount(c.courses?.count, lang)}
        caption={money(c.courses?.revenue_cents, data.currency)} onClick={() => buyers("course")} />
      <MetricCard testId={CRM.perfMetric("products")} label={t("perf.products")} value={fmtCount(c.products?.count, lang)}
        caption={money(c.products?.revenue_cents, data.currency)} onClick={() => buyers("product")} />
      <MetricCard testId={CRM.perfMetric("sessions_online")} label={t("perf.sessionsOnline")} value={fmtCount(c.sessions_online?.count, lang)}
        caption={t("perf.completed")} onClick={() => sessions("video")} />
      <MetricCard testId={CRM.perfMetric("sessions_offline")} label={t("perf.sessionsOffline")} value={fmtCount(c.sessions_offline?.count, lang)}
        caption={t("perf.completed")} onClick={() => sessions("in_person")} />
      <MetricCard testId={CRM.perfMetric("new_clients")} label={t("perf.newClients")} value={fmtCount(c.new_clients?.count, lang)}
        caption={t("perf.recordsCreated")}
        onClick={() => navigate(`${crmHref("/clients")}?${q({ sort: "created_at", dir: "desc", created_from: from, created_to: to })}`)} />
      <MetricCard testId={CRM.perfMetric("total_revenue")} tone="positive" label={t("perf.totalRevenue")}
        value={money(c.total_revenue_cents, data.currency)} caption={t("perf.allSales")} />
    </div>
  );
}
